export class MenuRegistro {

    public componentsAppMenu = [
        {
            label: 'Página Inicial', icon: 'home', routerLink: ['sistema/modulos']
        },
        {
            label: 'Registro', icon: 'recent_actors', items: [
                { label: 'Pessoa Física', icon: 'recent_actors', routerLink: ['menu/pessoa-fisica'] },
                { label: 'Pessoa Jurídica', icon: 'recent_actors', routerLink: ['menu/pessoa-juridica'] }
            ]
        },
        {
            label: 'Parametrização', icon: 'dashboard', items: [
                { label: 'Conselho Regional', icon: 'group_add', routerLink: ['parametrizacao/conselho-regional'] },
                { label: 'Órgão Expedidor', icon: 'group_add', routerLink: ['parametrizacao/orgao-expedidor'] },
                { label: 'Profissão', icon: 'group_add', routerLink: ['parametrizacao/profissao'] },
                { label: 'Delegacia', icon: 'group_add', routerLink: ['parametrizacao/delegacia'] },
                { label: 'Ofício', icon: 'group_add', routerLink: ['parametrizacao/oficio'] }
            ]
        },
        {
            label: 'Instituição Ensino', icon: 'account_balance', items: [
                { label: 'Tipo de Título', icon: 'collections_bookmark', routerLink: ['instituicao-ensino/tipo-titulo'] },
                { label: 'Natureza Título', icon: 'collections_bookmark', routerLink: ['instituicao-ensino/natureza-titulo'] },
                { label: 'Área Formação', icon: 'collections_bookmark', routerLink: ['instituicao-ensino/area-formacao'] },
                { label: 'Instituição', icon: 'collections_bookmark', routerLink: ['instituicao-ensino/instituicao'] }
            ]
        },
        {
            label: 'Serviços', icon: 'account_balance', items: [
                { label: 'Pessoa Física', icon: 'collections_bookmark', routerLink: ['servicos/gerenciar-servico'] },
                { label: 'Pessoa Jurídica', icon: 'collections_bookmark', routerLink: ['servicos/gerenciar-servico-pessoa-juridica'] },
                // { label: 'Gerenciar Serviços Gestor', icon: 'collections_bookmark', routerLink: ['servicos/gerenciar-servico-gestor'] },
                { label: 'Fila de Serviço', icon: 'collections_bookmark', routerLink: ['servicos/fila-servico'] },
            ]
        },
        {
            label: 'CNAIPJ', icon: 'account_balance', items: [
                { label: 'Solicitar CNAIPJ', icon: 'collections_bookmark', routerLink: ['cnaipj/solicitacao-cnaipj'] },
                { label: 'Homologar CNAIPJ', icon: 'collections_bookmark', routerLink: ['cnaipj/homologacao-cnaipj'] },
            ]
        },
        {
            label: 'Documentos', icon: 'account_balance', items: [
                { label: 'Certidão', icon: 'collections_bookmark', routerLink: ['documentos/certidao'] },
                { label: 'Certidão CNAIPJ', icon: 'collections_bookmark', routerLink: ['documentos/certidao-cnaipj/cadastrar'] },
                { label: 'Alvará', icon: 'collections_bookmark', routerLink: ['documentos/alvara'] },
                { label: 'Validar Documentos', icon: 'collections_bookmark', routerLink: ['documentos/validar-documentos'] }
            ]
        },
        {
            label: 'Comunicação', icon: 'account_balance', items: [
                { label: 'Solicitar Comunicação', icon: 'collections_bookmark', routerLink: ['comunicacao/solicitar-comunicacao'] },
                { label: 'Consultar Comunicação', icon: 'collections_bookmark', routerLink: ['comunicacao/consultar-comunicacao'] }
            ]
        },
        {
            label: 'Consultas', icon: 'account_balance', items: [
                { label: 'Registros por Delegacia', icon: 'collections_bookmark', routerLink: ['consultas/registros-delegacia'] },
                { label: 'Registros por Cidades', icon: 'collections_bookmark', routerLink: ['consultas/registros-delegacia-cidade'] },
                { label: 'Situação Cadastral', icon: 'collections_bookmark', routerLink: ['consultas/situacao-cadastral'] },
                { label: 'Pessoa Física', icon: 'collections_bookmark', routerLink: ['consultas/consulta-pessoa-fisica'] },
                { label: 'Pessoa Jurídica', icon: 'collections_bookmark', routerLink: ['consultas/consulta-pessoa-juridica'] },
                { label: 'CNAIPJ', icon: 'collections_bookmark', routerLink: ['consultas/consulta-cnaipj'] }
            ]
        },
    ];
}


// WEBPACK FOOTER //
// ./src/app/entity/menu.model.ts